import type React from 'react';
import CopyButton from '../copy-button';

export type CopyCodeProps = {
  readonly code: string;
  readonly onCopy?: () => void;
};

const CopyCode: React.FC<CopyCodeProps> = ({ code, onCopy }) => {
  return (
    <div className="w-full bg-white flex rounded-sm p-0 border border-gray-300">
      <div className="text-md overflow-x-auto whitespace-nowrap flex-grow flex items-center relative pl-3 after:content-[''] after:block after:z-10 after:sticky after:top-0 after:right-0 after:h-full after:min-w-3 after:bg-gradient-to-r after:from-transparent after:to-white">
        <span className="text-gray-600">{code}</span>
      </div>
      <CopyButton text={code} onCopy={onCopy} />
    </div>
  );
};

export default CopyCode;
